module.exports = __webpack_public_path__ + "img/aiznpg-1-sm.0b0300dd.jpg";